// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module--root--2YDVZ","left":"style-module--left--19OZQ","right":"style-module--right--1vTtK"};